import React from "react";

const FullPageLoader = ({ text = "Loading..." }) => {
  return (
    <div className="fullpage-loader">
      <div className="loader-content" role="status" aria-live="polite">
        <img
          src={`${process.env.PUBLIC_URL}/loader-v3.1.svg`}
          alt=""
          aria-hidden="true"
          style={{ width: "100px", height: "100px" }}
        />
        <span>{text}</span>
      </div>
    </div>
  );
};

export default FullPageLoader;